import { render, staticRenderFns } from "./UcCommentsList.yaml?vue&type=template&id=510bdf08&component"
import script from "./UcCommentsList.yaml?vue&type=script&lang=ts&component"
export * from "./UcCommentsList.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports